document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll<HTMLElement>('.privacymanager').forEach(trigger => {
        trigger.addEventListener('click', function(event){
            event.preventDefault();
            // @ts-ignore
            if (window.UC_UI instanceof Object) {
                // @ts-ignore
                window.UC_UI.showFirstLayer();
            } else {
                console.error('window.UC_UI not loaded!');
            }
            return false;
        });
    });

    document.querySelectorAll<HTMLElement>('#page-1976, #page-1949, #page-1959, #page-1975, #page-1977, #page-1923').forEach(trigger => {
        let attempts = 0;
        const maxAttempts = 100;

        const interval = setInterval(() => {
            // @ts-ignore
            if (window.UC_UI instanceof Object && window.UC_UI.isInitialized() === true)
            {
                // @ts-ignore
                window.UC_UI.closeCMP();
                clearInterval(interval); // Stop polling once it’s available
            } else if (++attempts >= maxAttempts) {
                clearInterval(interval); // Stop after max attempts
            }
        },
        100);
    })
});
